import React from 'react';
import { NumericFormat } from 'react-number-format';

interface TransactionInputProps {
  placeholder: string;
  onChange: (val: any) => void;
  disabled?: boolean;
  errorText?: string;
}

// TODO_R: [FRS]
// TODO_R: move into SendDialog/components/TokenInput/components
export const AmountInput = (props: TransactionInputProps) => {
  const { placeholder, onChange, disabled, errorText } = props;

  return (
    <div className="relative">
      <NumericFormat
        className="w-full h-48 rounded-[6px] text-m14 px-16 border-[.5px] border-black-4 bg-black-3 focus:border-primary focus-visible:outline-none"
        type="text"
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        disabled={disabled}
        onValueChange={(values) => {
          onChange(values.value);
        }}
        placeholder={placeholder}
      />
      {!!errorText && errorText !== '' && (
        <div className="text-m14 mt-8 text-error">{errorText}</div>
      )}
    </div>
  );
};
